import React from "react";

import PropTypes from "prop-types";

import { datadogRum } from "@datadog/browser-rum";
import ErrorPanel from "@/errors/ErrorPanel";

/* An error boundary component that forwards errors to the DataDog.
 * Utilize the RUM Browser SDK addError() API.
 * The collected rendering errors contain a component stack, which is unminified with our uploaded sourcemaps.
 */
class ErrorBoundary extends React.Component {
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    // Define a state variable to track whether is an error or not
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    const renderingError = new Error(error.message);
    renderingError.name = "ComponentLevelRenderingError";
    renderingError.stack = info.componentStack;
    renderingError.cause = error;

    datadogRum.addError(renderingError);
  }

  render() {
    // Check if the error is thrown
    if (this.state.hasError && !this.props.silent) {
      // You can render any custom fallback UI
      return React.createElement(this.props.FallbackComponent);
    }

    // Return children components in case of no error
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
  silent: PropTypes.bool,
  FallbackComponent: PropTypes.elementType,
};

ErrorBoundary.defaultProps = {
  silent: false,
  FallbackComponent: ErrorPanel,
};

export default ErrorBoundary;
